<script setup lang="ts">
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useForemanApiKeys } from '@/composables/core/foreman-api-keys'
import type { IForemanApiKeyForm } from '@/types/core/forms'

const apiKey = ref<string>()

const { createApiKeyMutation } = useForemanApiKeys()
const { isPending, mutateAsync, isError, error } = createApiKeyMutation

const open = defineModel<boolean>()
const emit = defineEmits(['closed'])

const submit = async () => {
  if (!apiKey.value || apiKey.value.trim() == '') {
    ElMessage.error('API key is required')
    return
  }

  const form: IForemanApiKeyForm = {
    api_key: apiKey.value,
  }

  await mutateAsync(form, {
    onSuccess: () => {
      open.value = false
    },
  })
}

/**
 * Reset form
 */
const handleClosed = () => {
  apiKey.value = undefined
  createApiKeyMutation.reset()
  emit('closed')
}
</script>

<template>
  <el-dialog
    v-model="open"
    :width="600"
    title="Submit API key"
    :show-close="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-input v-model="apiKey" clearable placeholder="Foreman API key" />
    <rl-error-alert v-if="isError" :error="error" />
    <template #footer>
      <el-button :disabled="isPending || !open" @click="open = false">Cancel</el-button>
      <el-button type="primary" :loading="isPending" :disabled="isPending || !open" @click="submit">Submit</el-button>
    </template>
  </el-dialog>
</template>
